import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Constants from '../Constants';

import wordmark from '../assets/menu-wordmark.png';

function PasswordResetView() {
  const [password, setPassword] = useState('');
  const [confirm_password, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams();

  const handleSubmit = async(e)=>{
    e.preventDefault();
    setError('');
    setSuccess(false);

    if(!password || !confirm_password) {
      setError('Both fields are required.');
      return;
    }
    if(password !== confirm_password) {
      setError('Passwords do not match.');
      return;
    }

    try {
      const url = Constants.SERVER_URL + '/api/auth/reset_password';
      const body = { token, password, confirm_password };
      const response = await axios.post(url, body);

      if(response && response.data && response.data.success) {
        // Force login after password reset
        localStorage.removeItem(Constants.TOKEN_NAME);
		    localStorage.removeItem(Constants.USER_ID);
        setSuccess(true);
        setTimeout(()=>{ navigate('/login'); }, 1500);
      } else {
        setError('Password reset failed.');
      }
    } catch(error) {
      if(error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      } else {
        setError('Server error during password reset.');
      }
    }
  };

  const render_form_input = (controlId, label, type, placeholder, value, setter)=>{
    return(
      <Form.Group className="mb-3" controlId={controlId}>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e)=>setter(e.target.value)}
          required
        />
      </Form.Group>
    );
  };

  	return (
      <Container fluid className='auth-container'>
      <Row className='auth-row'>
        <Col lg={4} md={6} sm={10} xs={11}>
        <Card className='auth-card'>
          <Card.Body className='auth-card-body'>
          
              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">Password reset successful</Alert>}

              <Form onSubmit={handleSubmit}>
                <img src={wordmark} className="signin-logo"/>
                <h3 className='auth-title'>Reset Password</h3>
                {render_form_input('newPassword', 'New Password', 'password', 'Enter new password', password, setPassword)}
                {render_form_input('confirm_password', 'Confirm Password', 'password', 'Confirm new password', confirm_password, setConfirmPassword)}

                <div className="d-grid mt-2">
                  <Button variant="primary" type="submit">Reset Password</Button>
                </div>
              </Form>

          </Card.Body>
        </Card>
        </Col>
      </Row>
      </Container>
    );


  // return(
  //   <Container fluid style={styles.container}>
  //     <Row style={styles.row}>
  //       <Col lg={4} md={6} sm={10} xs={11}>
  //         <Card style={styles.card}>
  //           <Card.Body>
  //             <h3 style={styles.title}>Reset Password</h3>

              // {error && <Alert variant="danger">{error}</Alert>}
              // {success && <Alert variant="success">Password reset successful</Alert>}

              // <Form onSubmit={handleSubmit}>
              //   {render_form_input('newPassword', 'New Password', 'password', 'Enter new password', password, setPassword)}
              //   {render_form_input('confirm_password', 'Confirm Password', 'password', 'Confirm new password', confirm_password, setConfirmPassword)}

              //   <div className="d-grid mt-2">
              //     <Button variant="primary" type="submit">Reset Password</Button>
              //   </div>
              // </Form>
  //           </Card.Body>
  //         </Card>
  //       </Col>
  //     </Row>
  //   </Container>
  // );
}

export default PasswordResetView;
